export const POLLS_FETCH_SUCCESS = "POLLS_FETCH_SUCCESS";
export const POLLS_FETCH_FAILURE = "POLLS_FETCH_FAILURE";
export const POLLS_SAVE_SUCCESS = "POLLS_SAVE_SUCCESS";
export const POLLS_SAVE_FAILURE = "POLLS_SAVE_FAILURE";
export const ARCHIVE_SAVE_SUCCESS = "ARCHIVE_SAVE_SUCCESS";
export const ARCHIVE_SAVE_FAILURE = "ARCHIVE_SAVE_FAILURE";
export const RESPONSE_SUBMITTED_SUCCESS = "RESPONSE_SUBMITTED_SUCCESS";
export const RESPONSE_SUBMITTED_FAILURE = "RESPONSE_SUBMITTED_FAILURE";
export const FETCH_RESPONSE_REPORT_SUCCESS = "FETCH_RESPONSE_REPORT_SUCCESS";
export const FETCH_RESPONSE_REPORT_FAILURE = "FETCH_RESPONSE_REPORT_FAILURE";
export const CLEAR_RESPONSE_REPORT = "CLEAR_RESPONSE_REPORT";
export const POLLS_CODE_COPY_SUCCESS = "POLLS_CODE_COPY_SUCCESS";
export const POLLS_CODE_COPY_FAILURE = "POLLS_CODE_COPY_FAILURE";
export const MAX_NUMBER_LIMIT = "MAX_NUMBER_LIMIT";
export const MIN_NUMBER_LIMIT = "MIN_NUMBER_LIMIT";
